import { getUserAgentDetails } from '@hh.ru/browser-api-utils';

(function () {
    window.bloko = window.bloko || {};
    window.bloko.getUserAgentDetails = getUserAgentDetails;
})();
